import React from 'react';
import './Testimonials.css';
import YouTubePlayer from './YouTubePlayer';

function Testimonials() {
  return (
    <section className="testimonials">
      <h2>עדויות לקוחות</h2>
      <div className="testimonials-container">
        <div className="testimonial-item">
          <p>״נדב עזר לי לשפר את התקשורת עם בן הזוג שלי בצורה משמעותית. ממליצה בחום!״</p>
          <p className="client-name">- מיכל, באר שבע</p>
        </div>
        <div className="testimonial-item">
          <p>״השירות של נדב שינה לי את החיים. למדתי להתמודד עם קונפליקטים בצורה חיובית יותר.״</p>
          <p className="client-name">- יוסי, אשקלון</p>
        </div>
        <div className="testimonial-item">
          <p>״הקורסים של נדב הם חווייתיים ומעשירים. קיבלתי כלים חשובים לשיפור מערכות היחסים שלי.״</p>
          <p className="client-name">- דנה, אשדוד</p>
        </div>
      </div>
      <YouTubePlayer/>

    </section>
    
  );
}

export default Testimonials;